import { MathUtils, Vector } from '@inter-ikea-core/core';
import { getPolygonCenter } from '../../../utils/math';
export const toCoreVector = (viewerVector, scale) => {
    return new Vector(viewerVector.x * scale, viewerVector.y * scale, viewerVector.z * scale);
};
export const getLineLength = (start, end) => {
    return Math.sqrt(Math.pow(end.X - start.X, 2.0) + Math.pow(end.Y - start.Y, 2.0) + Math.pow(end.Z - start.Z, 2.0));
};
export const getLineCenter = (start, end) => {
    return new Vector((start.X + end.X) * 0.5, (start.Y + end.Y) * 0.5, (start.Z + end.Z) * 0.5);
};
export const getRotation = (point, nextPoint) => {
    const nextPointAsVector = new Vector(nextPoint.X, nextPoint.Y, nextPoint.Z);
    const direction = nextPointAsVector.minus(point);
    const up = direction.cross(new Vector(0, 0, -1));
    const quaternionFromLookDirection = MathUtils.quaternionFromLookDirection(direction, up);
    const rotationAsQuaternion = MathUtils.quaternionFromEulerDegrees(new Vector(0, 90, 90));
    return rotationAsQuaternion.times(quaternionFromLookDirection);
};
export const getNextCorner = (corners, i) => {
    return corners[i !== corners.length - 1 ? i + 1 : 0];
};
/**
 * Checks that x-axis coordinate do not go past room dimensions
 * and if it does, return corrected value.
 * @param roomDimensions The rooms dimensions
 * @param x Point in x axis that shall be checked
 */
export const checkXWithRoomSize = (roomDimensions, x) => {
    if (x < roomDimensions.minX) {
        return roomDimensions.minX;
    }
    else if (x > roomDimensions.maxX) {
        return roomDimensions.maxX;
    }
    return x;
};
/**
 * Checks that y-axis coordinate do not go past room dimensions
 * and if it does, return corrected value.
 * @param roomDimensions The rooms dimensions
 * @param y Point in y axis that shall be checked
 */
export const checkYWithRoomSize = (roomDimensions, y) => {
    return Math.max(Math.min(y, roomDimensions.maxY), 0);
};
/**
 * Calculates the degree difference between to directions.
 * @param cameraDirection For instance the camera direction in euler degrees.
 * @param objectDirection Some entity or object direction in euler degrees.
 * @returns The degree diff in a numerical value.
 */
/**
 * Resets a polygons value so each point is relative to the polygon center
 * @param polygon The polygon
 * @returns The new polygon
 */
export function resetPolygonToXCenterAndYFloor(polygon) {
    const center = getPolygonCenter(polygon);
    return polygon.map(point => {
        return {
            x: point.x - center.x,
            y: point.y,
            z: point.z
        };
    });
}
/**
 * Moves a polygon to a new center
 * @param polygon The polygon
 * @param center The new center
 * @returns The new polygon
 */
export function movePolygonToCenter(polygon, center) {
    return polygon.map(point => {
        return {
            x: point.x + center.x,
            y: point.y,
            z: center.z
        };
    });
}
//# sourceMappingURL=HelpLinesUtils.js.map